import type { OnboardingResourceRenderType } from "@shared/schema";

const RENDER_TYPE_LABELS: Record<string, string> = {
  rich_doc: "Página",
  notion_mirror: "Sincronizado do Notion",
  process_steps: "Passo a passo",
  setup_checklist: "Checklist de ferramentas",
  tool_setup: "Ferramenta",
  slack_channel_info: "Canal do Slack",
  todo: "To-do",
};

export function labelForRenderType(
  rt: OnboardingResourceRenderType | string | null | undefined,
): string {
  if (!rt) return "—";
  return RENDER_TYPE_LABELS[rt] ?? rt;
}
